export const AddressSummaryName = 'addressSummaryComponent';
